'use client';

// =============================================================================
// TonConnectProvider — обёртка @tonconnect/ui-react. manifestUrl публичный
// в /tonconnect-manifest.json (см. /apps/miniapp/public).
//
// Используется в layout.tsx внутри <body>.
// =============================================================================

import { TonConnectUIProvider } from '@tonconnect/ui-react';

const MANIFEST_URL = 'https://prognoz.app/tonconnect-manifest.json';

export function TonConnectProvider({ children }: { children: React.ReactNode }) {
  return (
    <TonConnectUIProvider manifestUrl={MANIFEST_URL}>{children}</TonConnectUIProvider>
  );
}
